import * as React from 'react';

type Props = {
  className?: string;
};

export function ExclamationCircle({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-exclamationcircle"
      className={className}
    >
      <path
        d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 14C11.4477 14 11 13.5523 11 13V8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44772 13 8L13 13C13 13.5523 12.5523 14 12 14ZM12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17Z"
        fill="currentColor"
      />
    </svg>
  );
}
